import { createStore } from 'vuex';

import accounts from './modules/accounts';
import agentBots from './modules/agentBots';
import agentCapacityPolicies from './modules/agentCapacityPolicies';
import agents from './modules/agents';
import assignmentPolicies from './modules/assignmentPolicies';
import articles from './modules/helpCenterArticles';
import attributes from './modules/attributes';
import auditlogs from './modules/auditlogs';
import auth from './modules/auth';
import bulkActions from './modules/bulkActions';
import cannedResponse from './modules/cannedResponse';
import categories from './modules/helpCenterCategories';
import contactConversations from './modules/contactConversations';
import contactLabels from './modules/contactLabels';
import contactNotes from './modules/contactNotes';
import contacts from './modules/contacts';
import conversationLabels from './modules/conversationLabels';
import conversationMetadata from './modules/conversationMetadata';
import conversationPage from './modules/conversationPage';
import conversationResults from './modules/conversationResults';
import conversations from './modules/conversations';
import conversationSearch from './modules/conversationSearch';
import conversationStats from './modules/conversationStats';
import conversationTypingStatus from './modules/conversationTypingStatus';
import conversationWatchers from './modules/conversationWatchers';
import csat from './modules/csat';
import customRole from './modules/customRole';
import customViews from './modules/customViews';
import dashboardApps from './modules/dashboardApps';
import dashboardHome from './modules/dashboardHome';
import draftMessages from './modules/draftMessages';
import deals from './modules/deals';
import forms from './modules/forms';
import globalConfig from 'shared/store/globalConfig';
import inboxAssignableAgents from './modules/inboxAssignableAgents';
import inboxes from './modules/inboxes';
import inboxMembers from './modules/inboxMembers';
import integrations from './modules/integrations';
import pipelineAutomations from './modules/pipelineAutomations';
import crmConfig from './modules/crmConfig';
import pipelines from './modules/pipelines';
import labels from './modules/labels';
import macros from './modules/macros';
import notifications from './modules/notifications';
import marketingCosts from './modules/marketingCosts';
import metaCapiPixels from './modules/metaCapiPixels';
import metaAds from './modules/metaAds';
import products from './modules/products';
import lineItems from './modules/lineItems';
import portals from './modules/helpCenterPortals';
import reports from './modules/reports';
import scheduledMessages from './modules/scheduledMessages';
import bulkBroadcasts from './modules/bulkBroadcasts';
import segments from './modules/segments';
import socialComments from './modules/socialComments';
import socialInboxConfigs from './modules/socialInboxConfigs';
import socialResponseTemplates from './modules/socialResponseTemplates';
import socialPosts from './modules/socialPosts';
import tasks from './modules/tasks';
import tickets from './modules/tickets';
import sla from './modules/sla';
import slaReports from './modules/SLAReports';
import summaryReports from './modules/summaryReports';
import teamMembers from './modules/teamMembers';
import teams from './modules/teams';
import unifiedView from './modules/unifiedView';
import userNotificationSettings from './modules/userNotificationSettings';
import webhooks from './modules/webhooks';
import workflows from './modules/workflows';
import captainAssistants from './captain/assistant';
import captainAgentTools from './captain/agentTool';
import captainFlowSteps from './captain/flowStep';
import captainKnowledgeBases from './captain/knowledgeBase';
import captainDocuments from './captain/document';
import captainInboxes from './captain/inboxes';
import copilotThreads from './captain/copilotThreads';
import copilotMessages from './captain/copilotMessages';
import captainTools from './captain/tools';

const plugins = [];

export default createStore({
  modules: {
    accounts,
    agentBots,
    agentCapacityPolicies,
    agents,
    assignmentPolicies,
    articles,
    attributes,
    auditlogs,
    auth,
    bulkActions,
    cannedResponse,
    categories,
    contactConversations,
    contactLabels,
    contactNotes,
    contacts,
    conversationLabels,
    conversationMetadata,
    conversationPage,
    conversationResults,
    conversations,
    conversationSearch,
    conversationStats,
    conversationTypingStatus,
    conversationWatchers,
    csat,
    customRole,
    customViews,
    dashboardApps,
    dashboardHome,
    draftMessages,
    deals,
    forms,
    globalConfig,
    inboxAssignableAgents,
    inboxes,
    inboxMembers,
    integrations,
    pipelineAutomations,
    crmConfig,
    pipelines,
    labels,
    macros,
    notifications,
    marketingCosts,
    metaCapiPixels,
    metaAds,
    products,
    lineItems,
    portals,
    reports,
    scheduledMessages,
    bulkBroadcasts,
    segments,
    socialComments,
    socialInboxConfigs,
    socialResponseTemplates,
    socialPosts,
    tasks,
    tickets,
    sla,
    slaReports,
    summaryReports,
    teamMembers,
    teams,
    unifiedView,
    userNotificationSettings,
    webhooks,
    workflows,
    captainAssistants,
    captainAgentTools,
    captainFlowSteps,
    captainKnowledgeBases,
    captainDocuments,
    captainInboxes,
    copilotThreads,
    copilotMessages,
    captainTools,
  },
  plugins,
});
